import React from 'react';
import { Container } from 'components/UI';
import { Title, Image, LazyImage } from '@landing/ui';

import * as styles from './Offices.module.scss';

export default function Offices({ title, map, offices }) {
  return (
    <Container className={styles.container} background="gray" theme="stairs" padding="Vertical">
      <div className={styles.layout}>
        <Title>{title}</Title>
        <div className={styles.content}>
          {offices.map(({ title, items }) => (
            <div key={title} className={styles.group}>
              <div className={styles.groupTitle}>{title}</div>
              <ul className={styles.list}>
                {items.map(({ flag, country, mobileCountry, city }) => (
                  <li key={country} className={styles.item}>
                    <LazyImage className={styles.flag} src={flag} />
                    <span className={mobileCountry && styles.showTablet}>
                      {city ? `${country} – ${city}` : country}
                    </span>
                    <span className={styles.showMobile}>{mobileCountry}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <Image className={styles.mapWrap} classImage={styles.map} src={map} />
      </div>
    </Container>
  );
}
